import React from 'react';
import {GridList, GridTile} from 'material-ui/GridList';
import IconButton from 'material-ui/IconButton';
import FileUploadIcon from 'material-ui/svg-icons/file/file-upload';


const styles = {
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '10px',
    justifyContent: 'space-around',
  },
  gridList: {
    width: '60%',
    marginLeft: '40px',
    marginRight: '40px',
    height: '100%',
    overflowY: 'auto',
  },
};

export default class LocationPhotos extends React.Component {
  
  render() {
    const emptyImage = '/placeholder.png';

    const tilesData = [ 
      {
        img: this.props.location.companySplash || emptyImage,
        title: 'Company Splash Image',
        propName: 'companySplash'
      },
      {
        img: this.props.location.companyLogoWelcome || emptyImage,
        title: 'Welcome Logo',
        propName: 'companyLogoWelcome'
      },
      {
        img: this.props.location.companyPhoto1 || emptyImage,
        title: 'Profile Photo 1',
        propName: 'companyPhoto1'
      },
       {
        img: this.props.location.companyPhoto2 || emptyImage,
        title: 'Profile Photo 2',
        propName: 'companyPhoto2'
      },
       {
        img: this.props.location.companyPhoto3 || emptyImage,
        title: 'Profile Photo 3',
        propName: 'companyPhoto3'
      },
       {
        img: this.props.location.companyPhoto4 || emptyImage,
        title: 'Profile Photo 4',
        propName: 'companyPhoto4'
      },
    ]


    return (
    <div style={styles.root}>
      <GridList
        cols={2}
        cellHeight={200}
        padding={1}
        style={styles.gridList}
      >
        {tilesData.map((tile) => (
          <GridTile
            key={tile.title}
            title={tile.title}
            actionIcon={<IconButton onClick={() => this.props.onUpload? this.props.onUpload(tile.propName) : ''}><FileUploadIcon color="white" /></IconButton>}
            actionPosition="left"
            titlePosition="top"
            titleBackground="linear-gradient(to bottom, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0.3) 70%,rgba(0,0,0,0) 100%)"
            cols={tile.featured ? 3 : 1}
            rows={tile.featured ? 3 : 1}
          >
            <img src={tile.img} alt="tile"/>
          </GridTile>
        ))}
      </GridList>
    </div>
    );
  }


}


// WEBPACK FOOTER //
// ./src/components/LocationPhotos.js